import { render, staticRenderFns } from "./captainCard.vue?vue&type=template&id=5a98aa05&scoped=true&"
import script from "./captainCard.vue?vue&type=script&lang=js&"
export * from "./captainCard.vue?vue&type=script&lang=js&"
import style0 from "./captainCard.vue?vue&type=style&index=0&id=5a98aa05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a98aa05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a98aa05')) {
      api.createRecord('5a98aa05', component.options)
    } else {
      api.reload('5a98aa05', component.options)
    }
    module.hot.accept("./captainCard.vue?vue&type=template&id=5a98aa05&scoped=true&", function () {
      api.rerender('5a98aa05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tracking/partials/captainCard.vue"
export default component.exports